import { Box, Flex, Text, ThemeIcon } from '@mantine/core'
import { useResponsiveHooks } from '../hooks/useResponsiveHook'

interface StatusBoxProps {
	color: string
	bg: string
	label: string
	count: number
}

export const StatusBox = ({ color, bg, label, count }: StatusBoxProps) => {
	const { isMobile } = useResponsiveHooks()
	return (
		<Box
			style={{
				backgroundColor: bg,
				padding: 10,
				borderRadius: '12px',
				width: '32%',
			}}
		>
			<Flex gap='xs' align='center' mb={4}>
				<ThemeIcon size={10} radius='xl' color={color} />
				<Text
					fw={500}
					size={isMobile ? '10px' : 'xs'}
					style={{
						textWrap: 'nowrap',
					}}
				>
					{label}
				</Text>
			</Flex>
			<Text fw={700} size='sm'>
				{count}
			</Text>
		</Box>
	)
}
